import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api";

const COUNTRIES = [
  { code: "", label: "—" },
  { code: "DE", label: "Deutschland" },
  { code: "AT", label: "Österreich" },
  { code: "CH", label: "Schweiz" },
  { code: "IT", label: "Italien" },
  { code: "FR", label: "Frankreich" },
  { code: "OTHER", label: "Anderes Land" },
];

export default function NewRental() {
  const navigate = useNavigate();
  const [locations, setLocations] = useState([]);
  const [form, setForm] = useState({
    salutation: "",
    first_name: "",
    last_name: "",
    customer_email: "",
    phone: "",
    country: "DE",
    location_id: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.listLocations().then(setLocations).catch(() => {});
  }, []);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const r = await api.createRental({
        ...form,
        location_id: form.location_id || null,
        item_ids: [],
      });
      navigate(`/rentals/${r.rental_id}`);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  const valid = form.first_name.trim() && form.last_name.trim() && form.customer_email.trim();

  return (
    <div className="space-y-4 max-w-2xl">
      <div>
        <h1 className="text-2xl">Verleih manuell anlegen</h1>
        <p className="text-fh-gray text-sm mt-1">
          Nur als Fallback nutzen — normalerweise registrieren sich Kunden selbst über den QR-Code unter
          <code className="font-mono text-xs bg-fh-gray-light px-1 mx-1">/rental</code>.
          Items werden im nächsten Schritt zugewiesen.
        </p>
      </div>

      <form onSubmit={onSubmit} className="card p-5 space-y-4">
        {error && (
          <div className="bg-fh-red/10 border-l-4 border-fh-red px-3 py-2 rounded text-sm text-fh-red-dark">
            {error}
          </div>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <div>
            <label className="label-field">Anrede</label>
            <select className="input-field" value={form.salutation} onChange={(e) => set("salutation", e.target.value)}>
              <option value="">—</option>
              <option value="Herr">Herr</option>
              <option value="Frau">Frau</option>
              <option value="Divers">Divers</option>
            </select>
          </div>
          <div>
            <label className="label-field">Vorname *</label>
            <input className="input-field" required value={form.first_name} onChange={(e) => set("first_name", e.target.value)} />
          </div>
          <div>
            <label className="label-field">Nachname *</label>
            <input className="input-field" required value={form.last_name} onChange={(e) => set("last_name", e.target.value)} />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div>
            <label className="label-field">Email *</label>
            <input type="email" className="input-field" required value={form.customer_email} onChange={(e) => set("customer_email", e.target.value)} />
          </div>
          <div>
            <label className="label-field">Telefon</label>
            <input type="tel" className="input-field" value={form.phone} onChange={(e) => set("phone", e.target.value)} />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div>
            <label className="label-field">Land</label>
            <select className="input-field" value={form.country} onChange={(e) => set("country", e.target.value)}>
              {COUNTRIES.map((c) => <option key={c.code} value={c.code}>{c.label}</option>)}
            </select>
          </div>
          <div>
            <label className="label-field">Standort</label>
            <select className="input-field" value={form.location_id} onChange={(e) => set("location_id", e.target.value)}>
              <option value="">—</option>
              {locations.map((l) => (
                <option key={l.id} value={l.id}>{l.name}{l.is_partner ? " (Partner)" : ""}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="flex justify-end gap-2 pt-2">
          <button type="button" onClick={() => navigate(-1)} className="btn-secondary" disabled={submitting}>
            Abbrechen
          </button>
          <button type="submit" className="btn-primary" disabled={!valid || submitting}>
            {submitting ? "Wird angelegt…" : "Anlegen + Items zuweisen →"}
          </button>
        </div>
      </form>
    </div>
  );
}
